import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet, useLocation } from "react-router";
import { ApiError, api } from "../../lib/api";
import { ForcePasswordChange } from "./ForcePasswordChange";
import "./auth.css";

export function AuthGate() {
  const location = useLocation();
  const me = useQuery({
    queryKey: ["auth", "me"],
    queryFn: api.me,
    retry: false,
    staleTime: 30_000,
  });

  if (me.isPending) {
    return (
      <div className="auth-screen">
        <div className="auth-status-card">
          <div className="auth-spinner" />
          <strong>Sprawdzam sesję</strong>
          <span>Łączenie z Golf Scoring v2…</span>
        </div>
      </div>
    );
  }

  if (me.isError) {
    if (me.error instanceof ApiError && me.error.status === 401) {
      return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
    }
    return (
      <div className="auth-screen">
        <div className="auth-status-card error">
          <span className="auth-kicker">STAGING V2</span>
          <strong>Backend nie jest gotowy do logowania</strong>
          <p>{me.error instanceof Error ? me.error.message : "Nie udało się sprawdzić sesji."}</p>
          <button className="primary-button" type="button" onClick={() => void me.refetch()}>Spróbuj ponownie</button>
        </div>
      </div>
    );
  }

  if (me.data.user.mustChangePassword) {
    return <ForcePasswordChange name={me.data.user.name} email={me.data.user.email} />;
  }

  return <Outlet />;
}
